"use strict";var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");require("core-js/modules/es.array.for-each");require("core-js/modules/es.object.keys");require("core-js/modules/web.dom-collections.for-each");exports.__esModule = true;exports.default = void 0;

var _is = require("./is");



var _json = require("./json");

var _queryString = _interopRequireDefault(require("./queryString"));











function toQuery(body) {
  return _queryString.default.stringify(body);
}



function toFormData(body) {
  if (!(0, _is.isObj)(body)) return null;
  var fd = new FormData();

  var b = body;

  Object.keys(b).forEach(function (key) {
    var val = b[key];

    var validVal = null;

    if ((0, _is.isFile)(val) || (0, _is.isBlob)(val) || (0, _is.isStr)(val)) {
      validVal = val;
    } else if ((0, _is.isNum)(val)) {
      validVal = "" + val;
    }

    if (validVal !== null) {
      fd.append(key, validVal);
    } else {
      console.warn("value of " + key + " is invalid for FormData: " + val);
    }
  });

  return fd;
}



function toJSON(body) {
  if ((0, _is.isNil)(body)) return null;
  return (0, _json.str)(body);
}

/**
   * Подготавливает body для запросов  в виде json, query-параметров или FormData
   *
   * @param {InputType} [arg]
   * @param {null | void | AnyMap} [arg.body]
   * @param {'json' | 'query' | 'formData' | void} [arg.as] ожидаемый формат, если не указан, то json
   * @example
   * prepareRequestBody( { body: { file: Blob }, as: 'formData' } )
   * // FormData { file: Blob }
   *
   * prepareRequestBody( { body: { x: 3 } } )
   * // "{\"x\":3}"
   *
   * prepareRequestBody( { body: { a: 1, b: 2 }, as: 'query' } )
   * // "?a=1&b=2"
   *
   * prepareRequestBody( { body: undefined } )
   * // null
   * @returns {BodyOutType: null | string | FormData}
   */
var prepareRequestBody = function prepareRequestBody(arg) {
  var argObj = (0, _is.isObj)(arg) ? arg : {};var
  body = argObj.body,asType = argObj.as;
  switch (asType) {
    case 'query':
      return toQuery(body);
    case 'formData':
      return toFormData(body);
    default:
      return toJSON(body);}

};var _default =

prepareRequestBody;exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/hlp/dist/prepareRequestBody.js
// module id = 167
// module chunks = 0